import { useScrollFadeIn, staggerStyle } from "@/hooks/useScrollFadeIn";

const courses = [
  { time: "60分", price: "¥25,000" },
  { time: "90分", price: "¥30,000" },
  { time: "120分", price: "¥35,000" },
  { time: "150分", price: "¥45,000" },
  { time: "180分", price: "¥55,000" },
  { time: "210分", price: "¥65,000" },
  { time: "240分", price: "¥75,000" },
];

const options = [
  { name: "乳首舐め", price: "¥2,000" },
  { name: "聖水", price: "¥3,000" },
];

const costumes = [
  { name: "ボンデージ", price: "¥1,000" },
  { name: "その他衣装", price: "¥1,000" },
];

const areas = [
  { name: "新宿・渋谷・鶯谷", fee: "無料", freeColor: true },
  { name: "池袋・五反田・錦糸町", fee: "+¥1,000", freeColor: false },
  { name: "アルファイン", fee: "+¥3,000", freeColor: false },
  { name: "その他エリア", fee: "+¥1,000〜", freeColor: false },
];

export default function PriceSection() {
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>();
  const { ref: bodyRef, style: bodyStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.1 });
  const { ref: desktopRef, visible } = useScrollFadeIn<HTMLDivElement>({ delay: 0.1 });

  return (
    <section id="price" className="py-10 md:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        {/* Heading */}
        <div ref={headRef} style={headStyle} className="text-center mb-7 md:mb-16">
          <p className="text-xs tracking-[0.4em] text-amber-700 uppercase mb-2 md:hidden">Price</p>
          <h2
            className="font-en text-2xl md:text-4xl font-light text-stone-800 tracking-widest"
          >
            PRICE
          </h2>
          <div className="w-8 md:w-10 h-px bg-amber-400 mx-auto mt-3 md:mt-5"></div>
        </div>

        {/* ===== MOBILE LAYOUT ===== */}
        <div ref={bodyRef} style={bodyStyle} className="block lg:hidden space-y-3">

          {/* Course カード */}
          <div className="bg-stone-50 border border-stone-100 px-4 py-4">
            <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-3 flex items-center gap-2">
              <span className="flex-1 h-px bg-amber-200"></span>
              Course
              <span className="flex-1 h-px bg-amber-200"></span>
            </h3>
            <div className="grid grid-cols-2 gap-x-3">
              {courses.map((c, i) => (
                <div key={i} className="flex items-center justify-between py-1.5 border-b border-stone-100">
                  <span className="text-xs text-stone-500 tracking-wide">{c.time}</span>
                  <span className="text-xs text-stone-800 font-medium tracking-wide">{c.price}</span>
                </div>
              ))}
            </div>
            <div className="mt-3 pt-2 border-t border-stone-100 flex flex-col gap-0.5">
              <p className="text-[10px] text-stone-400">※場所代・ホテル代はお客様負担</p>
              <p className="text-[10px] text-stone-400">※以降は30分ごとに¥10,000追加チャージ</p>
            </div>
          </div>

          {/* Options + Costume 横並び */}
          <div className="grid grid-cols-2 gap-3">
            {/* Options */}
            <div className="bg-stone-50 border border-stone-100 px-3 py-4">
              <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-3 text-center">Options</h3>
              {options.map((o, i) => (
                <div key={i} className="flex items-center justify-between py-1.5 border-b border-stone-100">
                  <span className="text-xs text-stone-500">{o.name}</span>
                  <span className="text-xs text-stone-800 font-medium">{o.price}</span>
                </div>
              ))}
            </div>

            {/* Costume */}
            <div className="bg-stone-50 border border-stone-100 px-3 py-4">
              <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-3 text-center">Costume</h3>
              {costumes.map((c, i) => (
                <div key={i} className="flex items-center justify-between py-1.5 border-b border-stone-100">
                  <span className="text-xs text-stone-500">{c.name}</span>
                  <span className="text-xs text-stone-800 font-medium">{c.price}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Area カード */}
          <div className="bg-stone-50 border border-stone-100 px-4 py-4">
            <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-3 flex items-center gap-2">
              <span className="flex-1 h-px bg-amber-200"></span>
              Area（交通費）
              <span className="flex-1 h-px bg-amber-200"></span>
            </h3>
            <div className="space-y-0">
              {areas.map((a, i) => (
                <div key={i} className="flex items-center justify-between py-2 border-b border-stone-100 last:border-b-0">
                  <span className="text-xs text-stone-500">{a.name}</span>
                  <span className={`text-xs font-medium ${a.freeColor ? "text-emerald-600" : "text-stone-700"}`}>
                    {a.fee}
                  </span>
                </div>
              ))}
            </div>
            <p className="text-[10px] text-stone-400 mt-2">※その他エリアはお気軽にご相談ください</p>
          </div>

        </div>

        {/* ===== DESKTOP LAYOUT ===== */}
        <div ref={desktopRef} className="hidden lg:grid grid-cols-5 gap-6 items-start">

          {/* LEFT: Course カード — 2/5 幅 */}
          <div className="col-span-2 bg-stone-50 border border-stone-100 px-6 py-6" style={staggerStyle(visible, 0, 0.1, 0.12)}>
            <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-5 flex items-center gap-2">
              <span className="flex-1 h-px bg-amber-200"></span>
              Course
              <span className="flex-1 h-px bg-amber-200"></span>
            </h3>
            <div className="space-y-0">
              {courses.map((c, i) => (
                <div key={i} className="flex items-center justify-between py-3 border-b border-stone-100">
                  <span className="text-sm text-stone-500 tracking-wider">{c.time}</span>
                  <span className="text-sm text-stone-800 font-medium tracking-wider">{c.price}</span>
                </div>
              ))}
            </div>
            <div className="mt-4 pt-3 border-t border-stone-100 space-y-1">
              <p className="text-[10px] text-stone-400 leading-relaxed">※場所代・ホテル代はお客様負担となります。</p>
              <p className="text-[10px] text-stone-400 leading-relaxed">※以降は30分ごとに¥10,000追加チャージ</p>
            </div>
          </div>

          {/* RIGHT: Options / Costume / Area */}
          <div className="col-span-3 flex flex-col gap-4" style={staggerStyle(visible, 1, 0.1, 0.12)}>

            {/* Options + Costume 横並びカード */}
            <div className="grid grid-cols-2 gap-4">
              {/* Options カード */}
              <div className="bg-stone-50 border border-stone-100 px-5 py-5">
                <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-4 flex items-center gap-2">
                  <span className="flex-1 h-px bg-amber-200"></span>
                  Options
                  <span className="flex-1 h-px bg-amber-200"></span>
                </h3>
                <div className="space-y-0">
                  {options.map((o, i) => (
                    <div key={i} className="flex items-center justify-between py-3 border-b border-stone-100">
                      <span className="text-sm text-stone-500">{o.name}</span>
                      <span className="text-sm text-stone-800 font-medium tracking-wider">{o.price}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Costume カード */}
              <div className="bg-stone-50 border border-stone-100 px-5 py-5">
                <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-4 flex items-center gap-2">
                  <span className="flex-1 h-px bg-amber-200"></span>
                  Costume
                  <span className="flex-1 h-px bg-amber-200"></span>
                </h3>
                <div className="space-y-0">
                  {costumes.map((c, i) => (
                    <div key={i} className="flex items-center justify-between py-3 border-b border-stone-100">
                      <span className="text-sm text-stone-500">{c.name}</span>
                      <span className="text-sm text-stone-800 font-medium tracking-wider">{c.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Area カード — 全幅 */}
            <div className="bg-stone-50 border border-stone-100 px-5 py-5">
              <h3 className="text-[10px] tracking-[0.35em] text-amber-700 uppercase mb-4 flex items-center gap-2">
                <span className="flex-1 h-px bg-amber-200"></span>
                Area（交通費）
                <span className="flex-1 h-px bg-amber-200"></span>
              </h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-0">
                <div className="flex items-center justify-between py-3 border-b border-stone-100">
                  <span className="text-sm text-stone-500">新宿・渋谷・鶯谷</span>
                  <span className="text-sm text-emerald-600 font-medium whitespace-nowrap">無料</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-stone-100">
                  <span className="text-sm text-stone-500">アルファイン</span>
                  <span className="text-sm text-stone-700 font-medium whitespace-nowrap">+¥3,000</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-stone-100">
                  <span className="text-sm text-stone-500">池袋・五反田・錦糸町</span>
                  <span className="text-sm text-stone-700 font-medium whitespace-nowrap">+¥1,000</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-stone-100">
                  <span className="text-sm text-stone-500">その他エリア</span>
                  <span className="text-sm text-stone-700 font-medium whitespace-nowrap">+¥1,000〜</span>
                </div>
              </div>
              <p className="text-[10px] text-stone-400 mt-3">※上記以外のエリアはお気軽にご相談ください</p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}
